export const GET_COLOR_PAGE_DATA: string = "GET_COLOR_PAGE_DATA";
export const GET_COLOR_PAGE_DATA_SUCCESS: string =
  "GET_COLOR_PAGE_DATA_SUCCESS";
export const GET_COLOR_PAGE_DATA_FAIL: string = "GET_COLOR_PAGE_DATA_FAIL";
export const RESET_COLOR_PAGE_DATA: string = "RESET_COLOR_PAGE_DATA";
